import type { LegalDraftPageLoader } from './legal-routes';

/**
 * 약관·개인정보처리방침 페이지 스위치(VITE_LEGAL_PAGES_ENABLED, 정확히 'true' 일 때만) — 빌드 시점 상수로 읽는다. 옛 이름
 * VITE_LEGAL_DRAFT_ENABLED(로컬 `.env.local`·옛 빌드 인자)도 한 릴리스 동안 함께 읽는다.
 * Vite 가 `import.meta.env.VITE_*` 를 빌드 때 문자열로 바꿔 넣으므로 끈 빌드에서는 아래 분기가 통째로
 * 지워진다: 약관 문서(`@repo/api-contracts/legal-drafts`)도 약관 페이지 청크도 dist 에 생기지 않는다
 * (`legal-draft-bundle.spec.ts` 가 실제 빌드로 본다). 런타임 값(`env`)으로 나누면 끈 빌드에도 받을 수 있는 청크가 남으므로 쓰지 않는다.
 * 이 파일은 import.meta 를 읽어 Jest 가 해석하지 못하므로 스펙은 이 모듈을 대체한다.
 */
export const loadLegalDraftPage: LegalDraftPageLoader | null =
  import.meta.env.VITE_LEGAL_PAGES_ENABLED === 'true' ||
  import.meta.env.VITE_LEGAL_DRAFT_ENABLED === 'true'
    ? async () => {
        const [{ LegalDocumentPage }, drafts] = await Promise.all([
          import('@/pages/legal-document'),
          import('@repo/api-contracts/legal-drafts'),
        ]);
        return { LegalDocumentPage, drafts };
      }
    : null;
